import http from "./http";
let resquest = "/apis";

//获取课程列表
export function getTrainingList(params) {
  return http.get(`${resquest}/cloud/training/albumPage`, params);
}

//获取课程详情
export function getTrainingDetails(id) {
  return http.get(`${resquest}/cloud/training/getAlbumInfo/${id}`);
}

//加入购物车
export function addCart(params) {
  return http.post(`${resquest}/cloud/trainingCart/add`, params);
}

//购物车列表
export function cartList(params) {
  return http.get(`${resquest}/cloud/trainingCart/page`, params);
}

//删除购物车
export function deleteCart(params) {
  return http.post(`${resquest}/cloud/trainingCart/delete`, params);
}

//提交审核
export function review(params) {
  return http.post(`${resquest}/cloud/trainingOrder/createByAlbum`, params);
}

//订单列表
export function orderList(params) {
  return http.get(`${resquest}/cloud/trainingOrder/page`, params);
}

//我的课程
export function myCourse(params) {
  return http.get(`${resquest}/cloud/training/myCourseByAlbum1`, params);
}

//在线学习详情
export function onlineStudy(params) {
  return http.get(`${resquest}/cloud/studyProgress/onlineStudy`, params);
}

//记录学习时长
export function recordStudyTime(params) {
  return http.post(
    `${resquest}/cloud/studyProgress/updateStudyProgress`,
    params,
  );
}

//学习进度,签到打卡列表
export function studyProgressList(params) {
  return http.get(`${resquest}/cloud/studyProgress/h5List`, params);
}

//成绩查询
export function getProgress(params) {
  return http.get(`${resquest}/cloud/studyProgress/getProgress`, params);
}
